import { PageWrapper } from 'components';
import { Trans, useTranslation } from 'react-i18next';

import { BREADCRUMBS } from '../keys';
import LABELS from './keys';
import { Icon, Wrapper } from './styles';

const PageUnavailable = () => {
  const { t } = useTranslation();
  const breadcrumbs = BREADCRUMBS.map((breadcrumb) => t(breadcrumb));
  return (
    <PageWrapper breadcrumbs={breadcrumbs}>
      <Wrapper>
        <Icon />
        <Trans i18nkey={LABELS.PAGE_UNAVAILABLE_MESSAGE[0]} defaults={LABELS.PAGE_UNAVAILABLE_MESSAGE[1]} components={{ br: <br /> }} />
      </Wrapper>
    </PageWrapper>
  );
};

export default PageUnavailable;
